// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallsheetReceivedPage_paginationRoot__jDW3Q .visually-hidden {
  /* react-bootstrap@2.x expects Bootstrap 5's \`.visually-hidden\` utility.
     Your project uses Bootstrap 4.6, so we define it locally. */
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.CallsheetReceivedPage_paginationRoot__jDW3Q .page-item.active .page-link {
  background-color: #00d1ff !important;
  border-color: #00d1ff !important;
  color: #fff !important;
}
.CallsheetReceivedPage_paginationRoot__jDW3Q .page-item .page-link {
  color: #00d1ff;
}
.CallsheetReceivedPage_paginationRoot__jDW3Q .page-item.disabled .page-link {
  color:#6c757d !important;
}

.CallsheetReceivedPage_RecipientText__0Ng2P {
  font-size: 0.9rem;
  line-height: 1.2;
}

.CallsheetReceivedPage_RecipientId__YEjVe {
  white-space: nowrap;
}

.CallsheetReceivedPage_RecipientEmail__4JvYs {
  max-height: none;
  overflow: visible;
}

.CallsheetReceivedPage_RecipientEmailText__qplHV {
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 768px) {
  .CallsheetReceivedPage_RecipientText__0Ng2P {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CallsheetReceivedPage.module.css"],"names":[],"mappings":"AAAA;EACE;gEAC8D;EAC9D,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".paginationRoot :global(.visually-hidden) {\n  /* react-bootstrap@2.x expects Bootstrap 5's `.visually-hidden` utility.\n     Your project uses Bootstrap 4.6, so we define it locally. */\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.paginationRoot :global(.page-item.active .page-link) {\n  background-color: #00d1ff !important;\n  border-color: #00d1ff !important;\n  color: #fff !important;\n}\n.paginationRoot :global(.page-item .page-link) {\n  color: #00d1ff;\n}\n.paginationRoot :global(.page-item.disabled .page-link) {\n  color:#6c757d !important;\n}\n\n.RecipientText {\n  font-size: 0.9rem;\n  line-height: 1.2;\n}\n\n.RecipientId {\n  white-space: nowrap;\n}\n\n.RecipientEmail {\n  max-height: none;\n  overflow: visible;\n}\n\n.RecipientEmailText {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n@media (max-width: 768px) {\n  .RecipientText {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationRoot": `CallsheetReceivedPage_paginationRoot__jDW3Q`,
	"RecipientText": `CallsheetReceivedPage_RecipientText__0Ng2P`,
	"RecipientId": `CallsheetReceivedPage_RecipientId__YEjVe`,
	"RecipientEmail": `CallsheetReceivedPage_RecipientEmail__4JvYs`,
	"RecipientEmailText": `CallsheetReceivedPage_RecipientEmailText__qplHV`
};
export default ___CSS_LOADER_EXPORT___;
